import { PaginationParams } from '@/common/types';
import { useCurrentOrganization } from '@/modules/core/hooks';
import useAccumulatedOptions from '@/utils/hooks/useAccumulatedOptions';

import { useProcessingRulesQuery } from '../queries';

interface Props {
  isUsed?: boolean;
  ruleId?: string;
}

const useProcessingRulesList = (params?: PaginationParams, props?: Props, enabled = true) => {
  const { observingOrganization } = useCurrentOrganization();

  const { data, isLoading, total, list, isFetching, page, totalPages } = useProcessingRulesQuery(
    observingOrganization.path,
    props?.isUsed,
    params,
    enabled
  );

  const { accumulated } = useAccumulatedOptions({
    options: list || [],
    currentPage: page || 1,
  });

  return {
    data,
    list: accumulated,
    total,
    isLoading,
    isFetching,
    page: page || 1,
    totalPages: totalPages || 0,
  };
};

export default useProcessingRulesList;
